<template>
  <div class="container">
    <p>
      The page you requested for is not Found, checkout Abiodun Fatai's
      <router-link to="/home">homepage</router-link>
    </p>
  </div>
</template>

<style scoped>
.container {
  padding: 9rem 2rem;
  background: #020617;
  color: #fff;
}
p {
  text-align: center;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 25px;
}
a {
  color: rgb(54, 106, 208);
}
</style>
